module.exports = __webpack_public_path__ + "media/misc/temp-image-3-8bfb4da6.jpg";